/**
 * 请求接口
 */

import http from "./http"
import queryString from "@/utils/queryString"
// import readFile from "@/utils/readFile"
// import qs from "qs"

/**
 * 获取活动详情
 * @param {*} param
 */
export const getActivityDetail = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/activity/details/${params.id}`
  return http.post({ url, params: {}, finalFunc, showLoading })
}

export const getWorksList = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const queryStr = queryString(params)
  const url = `/works/list?${queryStr}`
  return http.post({ url, params: {}, finalFunc, showLoading })
}

//获取我的作品列表
export const getmyWorksList = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  // const url = `/works/myWorks`
  const url = `/works/myWorks?activityId=${params.activityId}&page=${params.page}&size=${params.size}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getRegionData = ({ params = {}, finalFunc = null, showLoading = false } = {}) => {
  const url = `/region/data`
  return http.post({ url, params, finalFunc, showLoading })
}

export const uploadImg = ({
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  onUploadProgress = null,
  cancelToken = null,
  timeout = null
} = {}) => {
  const url = `/file/uploadImage`
  return http.post({ url, params, headers, timeout, finalFunc, showLoading, onUploadProgress, cancelToken })
}

export const commitInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/save`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const modifyInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/modify`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const registUserInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/save`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

//作品点赞
export const getThumbers = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/addLike`
  return http.post({ url, params, finalFunc, showLoading })
}

//根据活动获取用户信息
export const getuserdelit = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/detailsByActivityId/${params.activityId}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getUserDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/detailsByActivityId/${params.activityId}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const searchSchool = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/school/complete/search?keyword=${params.keyword}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const worksPraise = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const bodyParams = {
    nvcVal: window.getNVCVal()
  }
  const queryStr = queryString(params)
  const url = `/works/addLike?${queryStr}`
  return http.post({ url, params: bodyParams, headers, finalFunc, showLoading, showToast, interceptError: false })
}

//获取作品详情
export const getWorkDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/details/${params.id}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}
//补充作品类型
export const getReplenishWorksType = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/replenish/worksType`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getAdDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/ad/detail`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getWorkCollection = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/works/selected`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const uploadVideo = async ({
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  onUploadProgress = null,
  cancelToken = null,
  timeout = null
} = {}) => {
  const url = `/file/uploadVideo`
  return http.post({ url, params, headers, timeout, finalFunc, showLoading, onUploadProgress, cancelToken })
}

export const getUserInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/user/userId/${params.userId}`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const uploadVideoChunk = ({
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  onUploadProgress = null,
  cancelToken = null,
  timeout = null,
  showToast = true
} = {}) => {
  const url = `/file/upload/video/chunk`
  return http.post({ url, params, headers, timeout, finalFunc, showLoading, onUploadProgress, cancelToken, showToast })
}

export const mergeVideo = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = true } = {}) => {
  const url = `/file/merge/video`
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getShopInfo = ({
  pageInfo = {},
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  showToast = false
} = {}) => {
  const url = `/store/map/${pageInfo.page}/${pageInfo.pageSize}?v=${Date.now().toString() + Math.random().toString()}`
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getShopDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/store/detail?v=${Date.now().toString() + Math.random().toString()}`
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getActivityInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/activity/detail`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}
/**签到 */
export const signIn = (params = {}) => {
  const url = "/signIn/signIn"
  const headers = {
    "Content-Type": "application/json"
  }
  return http.post({ url, params, headers, showLoading: false, showToast: false, interceptError: false })
}
